// @flow

import React from 'react';
import { observer } from 'mobx-react';
import FontAwesome from 'react-fontawesome';
import { css } from 'glamor';

import Markdown from '~/components/global/Markdown';

const containerRule = css({
    border: '1px solid lightgrey',
    marginTop: '15px',
    fontSize: '15px',
    lineHeight: '25px',
    display: 'table',

    '@media(max-width: 768px)': {
        maxHeight: '100%',
    },
});

const finalContainer = css({
    minHeight: '240px',
});

const categoryRule = css({
    display: 'table-cell',
    verticalAlign: 'middle',
    backgroundColor: '#e0e0e0',
    color: '#484848',
    textAlign: 'center',
    minHeight: '130px',
    width: '120px',

    '@media(max-width: 768px)': {
        display: 'block',
        minHeight: 0,
        display: 'inline-block',
        fontSize: '0.8em',
        width: '100%',
    },
});

const iconRule = css({
    fontSize: '4em',

    '@media(max-width: 768px)': {
        display: 'inline-block',
        fontSize: '2em',
        lineHeight: '35px',
    },
});

const labelRule = css({
    fontSize: '0.8em',
    fontWeight: '600',
    textTransform: 'uppercase',
    display: 'block',
});

const barBackgroundRule = css({
    position: 'absolute',
    left: '16px',
    right: '16px',
    bottom: '1px',
    minHeight: '30px',
    lineHeight: '30px',

    '@media(max-width: 768px)': {
        bottom: '12px',
        left: '32px',
    },
});

const categoryBarBackgroundRule = css({
    left: 0,
    right: 0,
    bottom: 0,

    '@media(max-width: 768px)': {
        bottom: '1px',
        width: '100%',
        left: '16px',
    },
});

const barRule = css({
    background: 'linear-gradient(to right, #fff, rgb(228, 65, 34))',
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
    minHeight: '30px',
    lineHeight: '30px',

    '@media(max-width: 768px)': {
        left: '-16px',
        bottom: '-11px',
    },
});

const scoreRule = css({
    color: 'rgb(228, 65, 34)',
    paddingLeft: '10px',
});

const commentRule = css({
    display: 'table-cell',
    minHeight: '120px',
    position: 'relative',

    '& p': {
        fontWeight: 300,
        padding: '20px',
        textAlign: 'justify',
        paddingBottom: '35px',

        '@media(max-width: 768px)': {
            padding: '25px',
            paddingBottom: '35px',
        },
    },

    '@media(max-width: 768px)': {
        display: 'block',
        marginLeft: 0,
    },
});

const finalCommentRule = css({
    minHeight: '200px',
    padding: '25px',
    paddingTop: '20px',
    paddingBottom: '45px',
});

const finalScoreRule = css({
    backgroundColor: '#262626',
    color: 'white',
    textTransform: 'uppercase',
    minHeight: '50px',
    fontWeight: 600,
    wordSpacing: '5px',
    textAlign: 'center',
    lineHeight: '50px',
});

const heightRule = height =>
    css({
        '@media(min-width: 769px)': {
            height: `${height}px`,
        },
    });

@observer
export default class ScoreBox extends React.Component {
    props: {
        score: number,
        icon?: string,
        category: string,
        text: string,
        final?: boolean,
        height?: number,
    };

    render() {
        const { score, icon, category, text, final, height } = this.props;
        const heightStyle = height ? heightRule(height) : {};

        if (final) {
            return (
                <div { ...containerRule } { ...finalContainer } { ...heightStyle }>
                    <div { ...finalScoreRule }>
                        {category}
                    </div>
                    <div>
                        <div { ...finalCommentRule }>
                            <Markdown content={ text } />
                            {score ?
                                <div { ...barBackgroundRule }>
                                      <div
                                          { ...barRule }
                                          style={{ width: `${score}%` }}
                                      >
                                          <span { ...scoreRule }>
                                              {`${score}/100`}
                                          </span>
                                      </div>
                                  </div> :
                                null}
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div { ...containerRule }>
                <div { ...categoryRule }>
                    <div { ...iconRule }>
                        <FontAwesome name={ icon } />
                    </div>
                    <span { ...labelRule }>
                        {category}
                    </span>
                </div>
                <div { ...commentRule }>
                    <Markdown content={ text } />
                    {score ?
                        <div
                            { ...barBackgroundRule }
                            { ...categoryBarBackgroundRule }
                        >
                              <div { ...barRule } style={{ width: `${score}%` }}>
                                  <span { ...scoreRule }>
                                      {`${score}/100`}
                                  </span>
                              </div>
                          </div> :
                        null}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/global/ScoreBox/index.js